/**
 * @voltxampere/ui — BMP280 barometric pressure sensor variant (Sprint 48-7)
 *
 * Sprint 48-7 — New I2C/SPI activated barometric pressure sensor.
 * I2C 7-bit slave at address 0x76 (default; SDO pull-down) or 0x77
 * (SDO pull-up). 19-bit resolution pressure (300-1100 hPa) and 16-bit
 * temperature (-40°C..+85°C). Used in altimeters, weather stations,
 * GPS-augmentation altitude.
 *
 * Sensor activation layer reads:
 *   - 0xD0: chip ID (constant 0x58)
 *   - 0xF7..0xF9: pressure MSB:LSB:XLSB (20-bit raw)
 *   - 0xFA..0xFC: temperature MSB:LSB:XLSB
 *   - 0x88..0x9F: 24-byte calibration coefficients (factory-programmed)
 *
 * Reference: Bosch BMP280 datasheet (BST-BMP280-DS001-23, 2021).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorBmp280 = {
    id: "bmp280",
    nameTr: "BMP280 (I2C Barometrik Basınç Sensörü)",
    nameEn: "BMP280 (I2C Barometric Pressure Sensor)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "BMP280",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 3.3,
        // Sprint 48-7 — I2C activation metadata.
        i2cAddress: 0x76,
        i2cFrequency: 400_000,
        chipIdRegister: 0xd0,
        chipIdValue: 0x58,
        pressureRegister: 0xf7,
        temperatureRegister: 0xfa,
        calibrationStartRegister: 0x88,
        pressureRangeHpa: { min: 300, max: 1100 },
        temperatureRangeC: { min: -40, max: 85 },
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-bmp280.js.map